module.exports = __webpack_public_path__ + "static/media/world-lock-disable.074f9295.svg";